export const types = {
  SET_BUNDLES: 'SET_BUNDLES',
  RESET_CLIENT_INSTALL_FORM_DATA: 'RESET_CLIENT_INSTALL_FORM_DATA',
  SET_SELECTED_CLIENT_BUNDLE: 'SET_SELECTED_CLIENT_BUNDLE',
  SET_UPDATED_CLIENT_BUNDLE: 'SET_UPDATED_CLIENT_BUNDLE',
  CHANGE_EDIT_MODE_AND_CLIENT_BUNDLE_STATE: 'CHANGE_EDIT_MODE_AND_CLIENT_BUNDLE_STATE',
  SET_SELECTED_CLIENT_BUNDLE_INDEX: 'SET_SELECTED_CLIENT_BUNDLE_INDEX',
  RESET_SELECTED_CLIENT_BUNDLE_INDEX: 'RESET_SELECTED_CLIENT_BUNDLE_INDEX',
};
